import {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, TextField} from '@emoney/kyber';
import './copyable-form-control.less';

export default class CopyableFormControl extends Component {
	constructor(props) {
		super(props);

		this.state = {
			copying: false
		};

		this.saveInput = this.saveInput.bind(this);
		this.saveMessage = this.saveMessage.bind(this);
		this.copyToClipboard = this.copyToClipboard.bind(this);
	}

	saveInput(ref) {
		this.input = ref;
	}

	saveMessage(ref) {
		this.message = ref;
	}

	copyToClipboard() {
		this.input.select();
		if (!this.state.copying) {
			this.setState({
				copying: true
			});
			document.execCommand('copy');
			$(this.message)
				.toggle()
				.fadeOut({
					duration: 1500,
					complete: () => {
						this.setState({
							copying: false
						});
					}
				});
		}
	}

	render() {
		const {value} = this.props;
		const {copying} = this.state;

		return (
			<div className="form-group">
				<div className="input-group">
					<TextField
						saveRef={this.saveInput}
						readOnly
						value={value}
					/>
					<div className="input-group-btn copyable-form-control-button">
						<Button onClick={this.copyToClipboard}
							primary
						>
							{copying ? '✓' : 'Copy'}
						</Button>
					</div>
				</div>
				<div className="copyable-form-control-message-container">
					<div ref={this.saveMessage} className="copyable-form-control-message">Copied to clipboard</div>
				</div>
			</div>
		);
	}
}

CopyableFormControl.propTypes = {
	value: PropTypes.string
};

CopyableFormControl.defaultProps = {
	value: ''
};